import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import PublicLayout from 'layout/Public';
import { PUBLIC_CMS_API } from 'services/publicCms.service';

const PublicHtmlPage = Loadable(lazy(() => import('pages/public/PublicHtmlPage')));

// ==============================|| PUBLIC (NO AUTH) ROUTES ||============================== //

const PublicRoutes = {
  path: '/',
  element: <PublicLayout />,
  children: [
    { path: 'terms', element: <PublicHtmlPage />, handle: { publicApiPath: PUBLIC_CMS_API.terms } },
    { path: 'privacy-policy', element: <PublicHtmlPage />, handle: { publicApiPath: PUBLIC_CMS_API.privacyPolicy } },
    { path: 'about', element: <PublicHtmlPage />, handle: { publicApiPath: PUBLIC_CMS_API.about } },
    { path: 'faq', element: <PublicHtmlPage />, handle: { publicApiPath: PUBLIC_CMS_API.faq } }
  ]
};

export default PublicRoutes;
